import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'https://crm-youtube.vercel.app/api';

// Créer une instance axios avec configuration de base
const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Intercepteur pour ajouter le token JWT
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Intercepteur pour gérer les erreurs
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Token invalide ou expiré
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// Auth API
export const authAPI = {
  register: (data) => api.post('/auth/register', data),
  login: (data) => api.post('/auth/login', data),
  getMe: () => api.get('/auth/me'),
  forgotPassword: (email) => api.post('/auth/forgot-password', { email }),
  resetPassword: (token, password) => api.post(`/auth/reset-password/${token}`, { password }),
};

// Users API
export const usersAPI = {
  getAll: (params) => api.get('/users', { params }),
  getById: (id) => api.get(`/users/${id}`),
  create: (data) => api.post('/users', data),
  update: (id, data) => api.put(`/users/${id}`, data),
  delete: (id) => api.delete(`/users/${id}`),
  getMyChannels: () => api.get('/users/me/channels'),
  getMyVideos: (params) => api.get('/users/me/videos', { params }),
  assignChannels: (userId, channelIds) => api.post(`/users/${userId}/channels`, { channelIds }),
  removeChannel: (userId, channelId) => api.delete(`/users/${userId}/channels/${channelId}`),
};

// Channels API
export const channelsAPI = {
  getAll: (params) => api.get('/channels', { params }),
  getById: (id) => api.get(`/channels/${id}`),
  create: (data) => api.post('/channels', data),
  update: (id, data) => api.put(`/channels/${id}`, data),
  delete: (id) => api.delete(`/channels/${id}`),
  getVideos: (channelId, params) => api.get(`/channels/${channelId}/videos`, { params }),
};

// Videos API
export const videosAPI = {
  getAll: (params) => api.get('/videos', { params }),
  getById: (id) => api.get(`/videos/${id}`),
  create: (data) => api.post('/videos', data),
  update: (id, data) => api.put(`/videos/${id}`, data),
  delete: (id) => api.delete(`/videos/${id}`),
  updateStatus: (id, data) => api.put(`/videos/${id}/status`, data),
};

// Resources API
export const resourcesAPI = {
  getByVideo: (videoId) => api.get(`/resources/videos/${videoId}/resources`),
  getById: (id) => api.get(`/resources/${id}`),
  create: (videoId, data) => {
    const formData = new FormData();
    Object.keys(data).forEach(key => {
      if (data[key] !== null && data[key] !== undefined) {
        if (key === 'file' && data[key] instanceof File) {
          formData.append('file', data[key]);
        } else {
          formData.append(key, data[key]);
        }
      }
    });
    return api.post(`/resources/videos/${videoId}/resources`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },
  update: (id, data) => {
    const formData = new FormData();
    Object.keys(data).forEach(key => {
      if (data[key] !== null && data[key] !== undefined) {
        if (key === 'file' && data[key] instanceof File) {
          formData.append('file', data[key]);
        } else {
          formData.append(key, data[key]);
        }
      }
    });
    return api.put(`/resources/${id}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },
  delete: (id) => api.delete(`/resources/${id}`),
  download: (id) => api.get(`/resources/${id}/download`, { responseType: 'blob' }),
};

// Comments API
export const commentsAPI = {
  getByVideo: (videoId) => api.get(`/videos/${videoId}/comments`),
  create: (videoId, text) => api.post(`/videos/${videoId}/comments`, { text }),
  update: (id, text) => api.put(`/comments/${id}`, { text }),
  delete: (id) => api.delete(`/comments/${id}`),
};

export default api;





